import styled from "styled-components"

export const FlexContainer = styled.div`
  display: flex;
`
